{
  "retry": "Réessayer",
  "notFound": "Module de formation introuvable.",
  "backToTraining": "Retour à la formation",
  "edit": "Modifier",
  "lessonsHeading": "Leçons",
  "newLesson": "Nouvelle leçon",
  "emptyTitle": "Aucune leçon",
  "emptyMessage": "Ajoutez une leçon à ce module pour commencer.",
  "videoProcessing": "En traitement",
  "videoFailed": "Échec de la vidéo",
  "video": "Vidéo"
}
